import DefaultList from "@/components/DefaultList";
import { PATH_DICTS_PAYROLL_DEPARTMENTS } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import {
  readPayrollDepartment,
  writePayrollDepartment,
} from "@/schemas/payrollDepartment";
import {
  ReadPayrollDepartment,
  WritePayrollDepartment,
} from "@/types/payrollDepartment";
import { CalendarClock } from "lucide-react";
import { PayrollDepartmentsService } from "@/modules/payrollDepartments/service";
import PayrollDepartmentCreator from "@/modules/payrollDepartments/components/PayrollDepartmentCreator";
import PayrollDepartmentEditor from "@/modules/payrollDepartments/components/PayrollDepartmentEditor";

const id = Module.PayrollDepartments;
const path = PATH_DICTS_PAYROLL_DEPARTMENTS;
const ns = "payrollDepartments";

const config: DictionaryConfig<ReadPayrollDepartment, WritePayrollDepartment> =
  {
    id,
    ns,
    service: PayrollDepartmentsService,
    path,
    labels: createDictionaryLabels(ns),
    getLabels: getDictionaryLabels,
    schema: writePayrollDepartment,
    defaultValues: {
      name: "",
      description: "",
    },
    Icon: CalendarClock,
    List: () => (
      <DefaultList<ReadPayrollDepartment>
        schema={readPayrollDepartment}
        name={ns}
        fetchList={PayrollDepartmentsService.getList}
        pathBuilder={(row) => `${path}/${row.id}`}
        tableFeatures={{
          ...defaultDictionaryTableFeatures,
          exportSettings: { moduleName: Module.PayrollDepartments },
        }}
      />
    ),
    Creator: PayrollDepartmentCreator,
    Editor: PayrollDepartmentEditor,
  };

export default config;
